module.exports = __webpack_public_path__ + "static/media/outdr_logo_light_144.de774604.webp";